import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";


// Notification By user id
export const getNotificationbyUserid= async (id) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        `${apiendpoints.MANAGE_GET_NOTIFICATION_USERID}?userId=${id}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };


// Notification By Id
export const getNotificationbyId= async (id) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        `${apiendpoints.MANAGE_GET_NOTIFICATION_ID}?id=${id}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };

// Notification unread message count for user
export const getNotificationUnreadMessageCount= async (id) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        `${apiendpoints.MANAGE_UNREAD_MESSAGE_COUNT_FOR_USER}?ToUser=${id}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };

// Notification update read status 
  export const getNotificationUpdateReadStatus= async (id) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.post(
        `${apiendpoints.MANAGE_UPDATE_READ_STATUS}?messageId=${id}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };
 
  // Email Notification For Firebase Messaging
  export const sendEmailNotification = async (data) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.post(
        `${apiendpoints.SEND_NOTIFICATION_AS_EMAIL}`,
        data
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };
 